module.exports = __webpack_public_path__ + "img/07.ddd97527.jpg";